import React, { FC, ReactNode } from 'react';
import Stack, { StackProps } from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';

interface Props extends StackProps {
  children: ReactNode;
}

export const Overlay: FC<Props> = ({ children, bgcolor, ...props }) => {
  const theme = useTheme();
  const defaultBgColor = theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.9)' : 'rgba(255, 255, 255, 0.9)';

  return (
    <Stack
      position="absolute"
      margin="0 !important"
      top={0}
      left={0}
      height="100%"
      width="100%"
      {...props}
      zIndex={5}
      direction="column"
      alignItems="center"
      justifyContent="center"
      bgcolor={bgcolor ?? defaultBgColor}
    >
      {children}
    </Stack>
  );
};
